import { createTheme } from "@mui/material";

const defaultTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#002147",
      light: "#ffffff",
      contrastText: "#000",
    },
    secondary: {
      main: "#3b5998",
      light: "#f5f5f5",
    },
    text: {
      primary: "#f5f5f5",
      secondary: "#fdd025",
    },
  },
  typography: {
    fontSize: 12,
    fontFamily: "Roboto, Arial, sans-serif",
  },
});

export default defaultTheme;
